// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pos-system .site-layout .products-col {
  overflow: hidden;
  padding: 10px;
  cursor: pointer;
  position: relative;
}
.pos-system .site-layout .products-col:hover .preview {
  display: flex;
}
.pos-system .site-layout .products-col .preview {
  display: none;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 14;
  background-color: rgba(255, 255, 255, 0.5);
}
.pos-system .site-layout .products-col .show-bonus {
  position: absolute;
  right: 0;
  top: 0;
  background: #283142;
  color: white;
  border-radius: 8px;
  padding: 3px 12px;
}
.pos-system .site-layout .products-col .ant-card-cover img {
  height: 160px;
  object-fit: contain;
}
.pos-system .site-layout .card-save {
  width: 100%;
}
.pos-system .site-layout .card-save .all-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.pos-system .site-layout .card-save .all-price .title {
  font-weight: 800;
}
.pos-system .site-layout .card-save .all-price .clear-all {
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
  color: var(--danger);
  font-weight: 800;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 100px;
  padding: 18px 0;
  border-bottom: 1px solid var(--border-color);
  gap: 10px;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-img {
  height: 50px;
  margin-right: 10px;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-img .ant-image {
  width: 100%;
  height: 100%;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-img .ant-image img {
  width: 100%;
  height: 100%;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-col {
  width: 100%;
  height: 100%;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-col .product-name {
  font-weight: 600;
  font-size: 16px;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-col .extras-color {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-col .extras-text {
  display: block;
  text-align: center;
  min-width: 30px;
  padding: 3px;
  border: 1px solid var(--grey);
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-col .extras-image {
  width: 30px;
  height: 30px;
  object-fit: contain;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-col .product-counter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-col .product-counter span span {
  color: var(--danger);
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-col .product-counter .count {
  display: flex;
  align-items: center;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-col .product-counter .count span {
  margin: 0 10px;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-col .product-counter .count .button-counter {
  outline: none !important;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.5);
  border: none;
  background: #f8f8f8;
}
.pos-system .site-layout .card-save .custom-cart-container .product-row .product-col .product-counter .count .button-counter:nth-child(4) {
  margin-left: 10px;
  background: rgba(234, 234, 234, 0.55);
}
.pos-system .site-layout .card-save .all-price-row {
  margin-top: 10px;
  border-bottom: 1px solid var(--border-color);
}
.pos-system .site-layout .card-save .all-price-row .col {
  padding: 0 12px;
}
.pos-system .site-layout .card-save .all-price-row .col .all-price-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  margin-bottom: 8px;
}
.pos-system .site-layout .card-save .submit-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  padding-top: 20px;
  border-top: 1px solid var(--border-color);
}
.pos-system .site-layout .card-save .submit-row .col {
  display: flex;
  flex-direction: column;
}
.pos-system .site-layout .card-save .submit-row .col span {
  font-weight: 700;
  font-size: 14px;
}
.pos-system .site-layout .card-save .submit-row .col span:nth-child(2) {
  font-size: 18px;
}
.pos-system .site-layout .card-save .submit-row .col2 {
  margin-right: 12px;
}

[data-theme=dark] .pos-system .site-layout .ant-card-bordered .ant-card-cover {
  margin: 0;
}
[data-theme=dark] .pos-system .site-layout .products-col .preview {
  background-color: rgba(27, 37, 49, 0.5);
  border-radius: 0.625rem;
}
[data-theme=dark] .pos-system .site-layout .order-tabs .tabs .tab.active {
  background-color: var(--dark-background);
  border-color: var(--dark-background);
}
[data-theme=dark] .pos-system .site-layout .order-tabs .tabs .close-button {
  color: var(--light-text);
}
[data-theme=dark] .pos-system .site-layout .button-counter {
  outline: none !important;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.5);
  border: none;
  background: #f8f8f8;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/page/pos-system.scss"],"names":[],"mappings":"AAEI;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AADN;AAGQ;EACE,aAAA;AADV;AAIM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,0CAAA;AAFR;AAIM;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAFR;AAIM;EACE,aAAA;EACA,mBAAA;AAFR;AAKI;EACE,WAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAHR;AAIQ;EACE,gBAAA;AAFV;AAIQ;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AAFV;AAOQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,4CAAA;EACA,SAAA;AALV;AAOU;EACE,YAAA;EACA,kBAAA;AALZ;AAMY;EACE,WAAA;EACA,YAAA;AAJd;AAMc;EACE,WAAA;EACA,YAAA;AAJhB;AASU;EACE,WAAA;EACA,YAAA;AAPZ;AASY;EACE,gBAAA;EACA,eAAA;AAPd;AAUY;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AARd;AAUY;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;AARd;AAUY;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AARd;AAUY;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AARd;AAUgB;EACE,oBAAA;AARlB;AAYc;EACE,aAAA;EACA,mBAAA;AAVhB;AAYgB;EACE,cAAA;AAVlB;AAagB;EACE,wBAAA;EACA,oCAAA;EACA,YAAA;EACA,mBAAA;AAXlB;AAcgB;EACE,iBAAA;EACA,qCAAA;AAZlB;AAoBM;EACE,gBAAA;EACA,4CAAA;AAlBR;AAmBQ;EACE,eAAA;AAjBV;AAkBU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AAhBZ;AAqBM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;AAnBR;AAoBQ;EACE,aAAA;EACA,sBAAA;AAlBV;AAmBU;EACE,gBAAA;EACA,eAAA;AAjBZ;AAmBU;EACE,eAAA;AAjBZ;AAoBQ;EACE,kBAAA;AAlBV;;AA4BM;EACE,SAAA;AAzBR;AA6BM;EACE,uCAAA;EACA,uBAAA;AA3BR;AAgCQ;EACE,wCAAA;EACA,oCAAA;AA9BV;AAgCQ;EACE,wBAAA;AA9BV;AAkCI;EAEE,wBAAA;EACA,oCAAA;EACA,YAAA;EACA,mBAAA;AAjCN","sourcesContent":[".pos-system {\n  .site-layout {\n    .products-col {\n      overflow: hidden;\n      padding: 10px;\n      cursor: pointer;\n      position: relative;\n      &:hover {\n        .preview {\n          display: flex;\n        }\n      }\n      .preview {\n        display: none;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 14;\n        background-color: rgba($color: #fff, $alpha: 0.5);\n      }\n      .show-bonus {\n        position: absolute;\n        right: 0;\n        top: 0;\n        background: #283142;\n        color: white;\n        border-radius: 8px;\n        padding: 3px 12px;\n      }\n      .ant-card-cover img {\n        height: 160px;\n        object-fit: contain;\n      }\n    }\n    .card-save {\n      width: 100%;\n\n      .all-price {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-top: 10px;\n        .title {\n          font-weight: 800;\n        }\n        .clear-all {\n          position: absolute;\n          top: 5px;\n          right: 10px;\n          cursor: pointer;\n          color: var(--danger);\n          font-weight: 800;\n        }\n      }\n\n      .custom-cart-container {\n        .product-row {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          min-height: 100px;\n          padding: 18px 0;\n          border-bottom: 1px solid var(--border-color);\n          gap: 10px;\n\n          .product-img {\n            height: 50px;\n            margin-right: 10px;\n            .ant-image {\n              width: 100%;\n              height: 100%;\n\n              img {\n                width: 100%;\n                height: 100%;\n              }\n            }\n          }\n\n          .product-col {\n            width: 100%;\n            height: 100%;\n\n            .product-name {\n              font-weight: 600;\n              font-size: 16px;\n            }\n\n            .extras-color {\n              display: block;\n              width: 20px;\n              height: 20px;\n              border-radius: 50%;\n            }\n            .extras-text {\n              display: block;\n              text-align: center;\n              min-width: 30px;\n              padding: 3px;\n              border: 1px solid var(--grey);\n            }\n            .extras-image {\n              width: 30px;\n              height: 30px;\n              object-fit: contain;\n            }\n            .product-counter {\n              display: flex;\n              justify-content: space-between;\n              align-items: center;\n              font-weight: 700;\n              span {\n                span {\n                  color: var(--danger);\n                }\n              }\n\n              .count {\n                display: flex;\n                align-items: center;\n\n                span {\n                  margin: 0 10px;\n                }\n\n                .button-counter {\n                  outline: none !important;\n                  box-shadow: 0 0 0 rgba(0, 0, 0, 0.5);\n                  border: none;\n                  background: #f8f8f8;\n                }\n\n                .button-counter:nth-child(4) {\n                  margin-left: 10px;\n                  background: rgba(234, 234, 234, 0.55);\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .all-price-row {\n        margin-top: 10px;\n        border-bottom: 1px solid var(--border-color);\n        .col {\n          padding: 0 12px;\n          .all-price-container {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            font-weight: 700;\n            margin-bottom: 8px;\n          }\n        }\n      }\n\n      .submit-row {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-top: 8px;\n        padding-top: 20px;\n        border-top: 1px solid var(--border-color);\n        .col {\n          display: flex;\n          flex-direction: column;\n          span {\n            font-weight: 700;\n            font-size: 14px;\n          }\n          span:nth-child(2) {\n            font-size: 18px;\n          }\n        }\n        .col2 {\n          margin-right: 12px;\n        }\n      }\n    }\n  }\n}\n\n[data-theme='dark'] .pos-system {\n  .site-layout {\n    .ant-card-bordered {\n      .ant-card-cover {\n        margin: 0;\n      }\n    }\n    .products-col {\n      .preview {\n        background-color: rgba($color: #1b2531, $alpha: 0.5);\n        border-radius: 0.625rem;\n      }\n    }\n    .order-tabs {\n      .tabs {\n        .tab.active {\n          background-color: var(--dark-background);\n          border-color: var(--dark-background);\n        }\n        .close-button {\n          color: var(--light-text);\n        }\n      }\n    }\n    .button-counter {\n      //background: none !important;\n      outline: none !important;\n      box-shadow: 0 0 0 rgba(0, 0, 0, 0.5);\n      border: none;\n      background: #f8f8f8;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
